
import { Component, Vue } from "vue-property-decorator";
import { SMUser, SMQuestionnaire } from "@/store";
import { API_ROUTES } from "@/utils/API";
import EmployeeDetailsSummaryPage from "@/components/EmployeeDetailsSummaryPage/EmployeeDetailsSummaryPage.vue";
import { TEmployeeLastName, TEmployeeName } from "@/models/employee-name";
import DetailsSummaryContainer from "@/components/DetailsSummaryPage/components/DetailsSummaryContainer.vue";
import { AxiosError } from "axios";
import { EMPLOYEE_EMPLOYMENT_STATUS_LEAVER } from "@/constants/compliance";

const ICONS = {
  lock: "lock-closed",
};

const CANDIDATE_DASHBOARD_ROUTE = "candidateDashboard";
const EMPLOYER_DASHBOARD_ROUTE = "employerDashboard";

@Component({
  components: {
    NotificationEmployeeTerminated: () =>
      import("@/components/Notifications/NotificationEmployeeTerminated.vue"),
    EmployeeDetailsSummaryPage,
    DetailsSummaryContainer,
  },
})
export default class EmployerEmployeesTemplatePersonalInfo extends Vue {
  employee: TEmployeeName = {} as TEmployeeName;

  icons = ICONS;

  // Not completed tasks dialog and logic;
  notCompletedTaskDialog = false;

  get homeDashboardRouteName() {
    if (SMUser.isEmployer) return EMPLOYER_DASHBOARD_ROUTE;

    if (SMUser.isCandidate) return CANDIDATE_DASHBOARD_ROUTE;

    return "";
  }

  viewNotCompletedTasks() {
    if (SMUser.isExpert) {
      const { companyId, employeeId } = this;

      return this.$router.push(`/expert/companies/${companyId}/employees/${employeeId}/summary`);
    }

    this.$router.push({ name: this.homeDashboardRouteName });
  }

  get isEmployeeTerminated() {
    return this.employee?.employee_working_status === EMPLOYEE_EMPLOYMENT_STATUS_LEAVER;
  }

  get canEdit() {
    if (SMUser.isExpert) return true;

    if (this.isEmployeeTerminated) return false;

    return SMUser.isEmployer;
  }

  getEmployeeName(employee: TEmployeeName | TEmployeeLastName) {
    const { title, first_name, last_name } = employee;

    let name = "";
    name += title ? `${title} ` : "";
    name += first_name ? `${first_name} ` : "";
    name += last_name ? last_name : "";

    return name;
  }

  get isLastNames() {
    return this.employee.last_names && this.employee.last_names.length;
  }

  mounted() {
    this.fetchEmployeeSummary();

    this.$root.$on("update-employee-level-data", this.fetchEmployeeSummary);
  }

  get employeeId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  get employeeNameEndpoint() {
    const { companyId, employeeId } = this;

    if (!employeeId) return "";

    if (companyId) return API_ROUTES.EXPERT_COMPANIES_EMPLOYEE_NAME_BY_ID(companyId, employeeId);

    return API_ROUTES.EMPLOYEE_NAME_BY_ID(employeeId);
  }

  async fetchEmployeeSummary() {
    if (!this.employeeNameEndpoint) return;

    const { data } = await this.axios.get(this.employeeNameEndpoint);

    if (!data) return;

    this.employee = data;
  }

  // Check for "service" edited
  // NOTE: Maybe we need to move it level upper
  async serviceEditCheck(payload: { stepId: number; type: string }) {
    const { stepId } = payload;
    const { id, company_id } = this.$route.params;

    const params = {
      target_user_id: id,
      company_id,
      stepId,
    };

    const { data } = await this.axios.get(API_ROUTES.COMPLIANCE_EDIT_CHECK(params));

    if (!data) return (this.notCompletedTaskDialog = true);

    return await this.confirmQuestionEditing(stepId, params);
  }

  // NOTE: Simplify and also move level upper;
  async confirmQuestionEditing(
    stepId: number | string,
    params: {
      target_user_id?: number | string;
      company_id?: number | string;
      type?: string;
    }
  ) {
    try {
      const { data } = await this.axios.get(API_ROUTES.COMPLIANCE_EDIT_STEP(stepId, params));

      if (!data) return;

      await SMQuestionnaire.openQuestionnaire(data.ID);
    } catch (e) {
      const error = e as AxiosError;

      if (error.response) {
        if (error.response.data.message == "already has edit flow") {
          this.notCompletedTaskDialog = true;
        }
      } else {
        console.log(e);
      }
    }
  }
}
